// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoriesCreate_title__3c19c"};